// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../statics/experience_update_info.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalExperienceUpdateInfo_modal_container__p82ly {
    /* width: 590px !important; */
    /* height: 606px; */
}

.ModalExperienceUpdateInfo_modal_container__p82ly .ant-modal-content {
    width: 100%;
    height: 606px;
    padding: 0 !important;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center / 100% 100%;
    border-radius: 15px;
}

.ModalExperienceUpdateInfo_modal_container__p82ly .ant-modal-body {
    width: 100%;
    height: 100%;
}

.ModalExperienceUpdateInfo_modal_container__p82ly .ant-modal-close {
    color: #f9f9f9;
    transition: background-color 0.5s;
}

.ModalExperienceUpdateInfo_modal_container__p82ly .ant-modal-close:hover {
    color: #fff;
    background-color: #aaa;
}

.ModalExperienceUpdateInfo_modal_container__p82ly .ant-modal-close:active {
    color: #fff;
    background-color: #ddd;
}

.ModalExperienceUpdateInfo_main__CEcTT {
    width: 100%;
    height: 100%;
    padding: 64px 100px;
    /* background-color: #fff; */
    /* background: url('../../../../statics/update_info_bg.png') no-repeat center / 100% 100%; */
}

.ModalExperienceUpdateInfo_header__3ph8o {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 46px;
    line-height: 46px;
    margin-bottom: 50px;
}

.ModalExperienceUpdateInfo_title__cuzPt {
    font-size: 38px;
    color: #fff;
}

.ModalExperienceUpdateInfo_content__mJtTJ {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 25px;
}

.ModalExperienceUpdateInfo_icon__2sh19 {
    width: 173px;
    height: 135px;
    margin-bottom: 10px;
}

.ModalExperienceUpdateInfo_progress__Tg3X7 {
    width: 100%;
    height: 40px;
    margin-bottom: 10px;
}

.ModalExperienceUpdateInfo_info_box__th8ic {
    width: 100%;
    margin-bottom: 10px;
}

.ModalExperienceUpdateInfo_info__CsdS7 {
    width: 100%;
    color: #fff;
    font-size: 16px;
    text-align: center;
    margin-bottom: 5px;
}

.ModalExperienceUpdateInfo_level_box__FTkNa {
    display: flex;
    justify-content: center;
    align-items: center;
}

.ModalExperienceUpdateInfo_level__hktep {
    font-size: 20px;
    color: #fff;
    text-align: center;
    margin-left: 10px;
}

.ModalExperienceUpdateInfo_lv_n_icon__3g21D {
    width: 36px;
    height: 36px;
}

.ModalExperienceUpdateInfo_footer__c695k {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 58px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/components/ModalExperienceUpdateInfo/index.module.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,gFAA8F;IAC9F,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,4BAA4B;IAC5B,4FAA4F;AAChG;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB","sourcesContent":[".modal_container {\n    /* width: 590px !important; */\n    /* height: 606px; */\n}\n\n.modal_container :global(.ant-modal-content) {\n    width: 100%;\n    height: 606px;\n    padding: 0 !important;\n    background: url('../../../../statics/experience_update_info.png') no-repeat center / 100% 100%;\n    border-radius: 15px;\n}\n\n.modal_container :global(.ant-modal-body) {\n    width: 100%;\n    height: 100%;\n}\n\n.modal_container :global(.ant-modal-close) {\n    color: #f9f9f9;\n    transition: background-color 0.5s;\n}\n\n.modal_container :global(.ant-modal-close:hover) {\n    color: #fff;\n    background-color: #aaa;\n}\n\n.modal_container :global(.ant-modal-close:active) {\n    color: #fff;\n    background-color: #ddd;\n}\n\n.main {\n    width: 100%;\n    height: 100%;\n    padding: 64px 100px;\n    /* background-color: #fff; */\n    /* background: url('../../../../statics/update_info_bg.png') no-repeat center / 100% 100%; */\n}\n\n.header {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 46px;\n    line-height: 46px;\n    margin-bottom: 50px;\n}\n\n.title {\n    font-size: 38px;\n    color: #fff;\n}\n\n.content {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 25px;\n}\n\n.icon {\n    width: 173px;\n    height: 135px;\n    margin-bottom: 10px;\n}\n\n.progress {\n    width: 100%;\n    height: 40px;\n    margin-bottom: 10px;\n}\n\n.info_box {\n    width: 100%;\n    margin-bottom: 10px;\n}\n\n.info {\n    width: 100%;\n    color: #fff;\n    font-size: 16px;\n    text-align: center;\n    margin-bottom: 5px;\n}\n\n.level_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.level {\n    font-size: 20px;\n    color: #fff;\n    text-align: center;\n    margin-left: 10px;\n}\n\n.lv_n_icon {\n    width: 36px;\n    height: 36px;\n}\n\n.footer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 58px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_container": `ModalExperienceUpdateInfo_modal_container__p82ly`,
	"main": `ModalExperienceUpdateInfo_main__CEcTT`,
	"header": `ModalExperienceUpdateInfo_header__3ph8o`,
	"title": `ModalExperienceUpdateInfo_title__cuzPt`,
	"content": `ModalExperienceUpdateInfo_content__mJtTJ`,
	"icon": `ModalExperienceUpdateInfo_icon__2sh19`,
	"progress": `ModalExperienceUpdateInfo_progress__Tg3X7`,
	"info_box": `ModalExperienceUpdateInfo_info_box__th8ic`,
	"info": `ModalExperienceUpdateInfo_info__CsdS7`,
	"level_box": `ModalExperienceUpdateInfo_level_box__FTkNa`,
	"level": `ModalExperienceUpdateInfo_level__hktep`,
	"lv_n_icon": `ModalExperienceUpdateInfo_lv_n_icon__3g21D`,
	"footer": `ModalExperienceUpdateInfo_footer__c695k`
};
export default ___CSS_LOADER_EXPORT___;
